import { NODE_TYPE_TEMPLATE } from './chatbotGraph'
import {
  getWaMappingHealth,
  remapWaComponentsToTemplate,
} from '../WorkflowHelper'

export function mappedTemplateKeys(chatbot) {
  const keys = []
  const seen = {}
  const nodes = (chatbot && chatbot.nodes) || []
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n || n.type !== NODE_TYPE_TEMPLATE) continue
    const key = String((n.data && n.data.waTemplateKey) || '').trim()
    if (!key || seen[key]) continue
    seen[key] = true
    keys.push(key)
  }
  return keys
}

export function indexWaTemplatePreviews(resp) {
  const map = {}
  const items = resp && Array.isArray(resp.items)
    ? resp.items
    : (resp && resp.waTemplateKey ? [resp] : [])
  for (let i = 0; i < items.length; i++) {
    const item = items[i]
    const key = item && String(item.waTemplateKey || '').trim()
    if (!key) continue
    map[key] = item
  }
  return map
}

export function brokenPreviewForKeys(keys, message) {
  const map = {}
  const msg = message || 'WhatsApp template details could not be loaded'
  ;(keys || []).forEach((key) => {
    const k = String(key || '').trim()
    if (!k) return
    map[k] = {
      waTemplateKey: k,
      _waHydrateError: msg,
    }
  })
  return map
}

export function cachedWaTemplatePreview(previewByKey, key) {
  const k = String(key || '').trim()
  if (!k || !previewByKey) return null
  const preview = previewByKey[k]
  if (!preview) return null
  if (preview.waTemplate || preview._waKeyBroken || preview._waKeyBrokenReason) return preview
  return null
}

export function overlayTemplateNodeData(data, preview) {
  const d = data || {}
  const key = String(d.waTemplateKey || '').trim()
  if (!key) return d
  if (!preview) return d

  const hydrateFailed = Boolean(preview._prereqWarning || preview._waHydrateError || preview._waKeyBroken)
  if (hydrateFailed || !preview.waTemplate) {
    return {
      ...d,
      waTemplate: null,
      templateIssue: preview._waHydrateError
        || preview._waKeyBrokenReason
        || 'WhatsApp template details could not be loaded for this key.',
    }
  }

  const remapped = remapWaComponentsToTemplate(
    preview.waTemplate,
    d.waComponents,
    preview.waComponents
  )
  const health = getWaMappingHealth({
    waTemplateKey: key,
    waTemplate: preview.waTemplate,
    waComponents: remapped,
  })
  return {
    ...d,
    waTemplate: preview.waTemplate,
    waComponents: remapped,
    templateIssue: health.broken
      ? (health.reason || 'WhatsApp template variables need to be remapped for the current template.')
      : null,
  }
}

export function overlayTemplateNodeDataFromMap(data, previewByKey) {
  const key = String((data && data.waTemplateKey) || '').trim()
  if (!key) return data || {}
  return overlayTemplateNodeData(data, previewByKey && previewByKey[key])
}

export function firstTemplateIssue(chatbot, previewByKey) {
  const nodes = (chatbot && chatbot.nodes) || []
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n || n.type !== NODE_TYPE_TEMPLATE) continue
    const issue = overlayTemplateNodeDataFromMap(n.data, previewByKey).templateIssue
    if (issue) return String(issue)
  }
  return ''
}

export function invalidStepsReason(title) {
  const name = String(title || '').trim()
  return name ? `Chatbot "${name}" has invalid steps` : 'There are invalid steps'
}
